// This icon file is generated automatically.
var PCheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.25 1.97h-1.1a.5.5 0 00-.38.19l-6.45 8.16-3.09-3.91a.5.5 0 00-.39-.2H.75c-.1 0-.16.13-.1.2l4.28 5.43c.2.25.59.25.79 0l7.63-9.67c.06-.08 0-.2-.1-.2z", "fill-rule": "nonzero" } }] }, "name": "p-check", "theme": "outlined" };
export default PCheckOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCheckOutlined.js
// module id = 3283
// module chunks = 0